import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Marker, Popup } from "react-leaflet";

const WeatherMarker = (props) => {
  const isLoggedIn = useSelector((state) => state.login.accessToken);
  const navigate = useNavigate();

  const convertToJalali = (x) => {
    if (!x) return "-";
    try {
      const A = x.slice(0, 10);
      const B = x.slice(11, 19);
      const C = new Date(A);
      const D = new Intl.DateTimeFormat("fa-IR").format(C);
      return `${D} (${B})`;
    } catch {
      return "-";
    }
  };

  if (props.type === "SATA2" && props.data.latitude) {
    return (
      <Marker position={[props.data.latitude, props.data.longitude]}>
        <Popup position={[props.data.latitude, props.data.longitude]}>
          <div
            dir="rtl"
            className="p-3 bg-white rounded text-dark"
            style={{ width: "320px" }}
          >
            {/* Station Title */}
            <h5 className="text-center border-bottom pb-1 mb-2 fw-bold">
              {props.data.stationName}
            </h5>

            {/* City & Province */}
            <div className="d-flex justify-content-between mb-1">
              <span>
                🏙️ <strong>شهر:</strong>
              </span>
              <span>{props.data.city}</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                📍 <strong>استان:</strong>
              </span>
              <span>{props.data.province}</span>
            </div>

            {/* Weather stats */}
            <div className="d-flex justify-content-between mb-1">
              <span>
                🌡️ <strong>دما:</strong>
              </span>
              <span dir="ltr">{props.data.temperature} °C</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                💧 <strong>رطوبت:</strong>
              </span>
              <span dir="ltr">{props.data.humidity} %</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                💨 <strong>باد:</strong>
              </span>
              <span dir="ltr">{props.data.wind_speed} m/s</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                🧭 <strong>جهت باد:</strong>
              </span>
              <span dir="ltr">{props.data.wind_direction}°</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                ☔ <strong>باران:</strong>
              </span>
              <span dir="ltr">{props.data.rain} mm</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                ❄️ <strong>برف:</strong>
              </span>
              <span dir="ltr">{props.data.snow} mm</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                💦 <strong>تبخیر:</strong>
              </span>
              <span dir="ltr">{props.data.evaporation} mm</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                🔆 <strong>تابش:</strong>
              </span>
              <span dir="ltr">{props.data.solar_radiation} W/m²</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>
                🌱 <strong>رطوبت خاک:</strong>
              </span>
              <span dir="ltr">{props.data.soil_moisture} %</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>
                🌡️ <strong>دما خاک:</strong>
              </span>
              <span dir="ltr">{props.data.soil_temperature} °C</span>
            </div>

            {/* Last Update */}
            <div className="border-top pt-1 text-center fs-6 text-muted">
              آخرین دیتا:{" "}
              <span dir="ltr" className="fw-semibold text-dark">
                {convertToJalali(props.data.ccreated_datetime)}
              </span>
            </div>

            {/* History Button */}
            {isLoggedIn && (
              <div className="d-flex justify-content-center mt-2">
                <button
                  className="btn btn-dark btn-sm"
                  onClick={() => navigate("/SATA-history/" + props.data.slug)}
                >
                  تاریخچه
                </button>
              </div>
            )}
          </div>
        </Popup>
      </Marker>
    );
  }

  return null;
};

export default WeatherMarker;
